export default __webpack_public_path__ + "static/media/menu_top_recordings_okara.62dd7160.svg";